// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root___mIvF","head":"Table_head__1KA7p","col":"Table_col__2114E"};